<template>
  <div class="attentionUserView" v-if="show_attention_view" :style="`left:${offsetLeft}px;top:${offsetTop}px`">
    <div class="userList" @scroll="handleScroll">
      <div class="title">选择昵称或轻敲空格完成输入</div>
      <div class="user" v-for="(item, index) in data" :key="index" @click="itemClickEvent(item)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>

import { types as UserTypes } from "../../store/modules/user";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "AttentionUser",
  components: {},
  props: {},
  data() {
    return {
      name: '',
      show_attention_view: false,
      offsetLeft: 0,
      offsetTop: 0
    };
  },
  watch: {},
  computed: {
    ...mapState({
        total_count: state => state.user.attention_user.total_count,
        page: state => state.user.attention_user.page,
        load_more: state => state.user.attention_user.load_more,
        data: state => state.user.attention_user.data,
    }),
    ...mapGetters({
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
        fetchData: UserTypes.FETCH_ATTENTION_USER_LIST
    }),
    itemClickEvent(item){
      let name = item.name
      if(this.$parent.attentionUserEvent){
        this.$parent.attentionUserEvent(name);
        this.hideView()
      }
    },
    handleScroll(e) {
      // console.log(e);
      var that = this;
      let height = e.target.offsetHeight;
      let scrollHeight = e.target.scrollHeight;
      let scrollTop = e.target.scrollTop;
      // console.log(height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据");
          that.loadData(that.page+1, that.name)
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },
    loadData(page, name){
      this.name = name;
      this.fetchData({page:page, name:name})
    },
    showView(page, name, offsetLeft, offsetTop){
      this.offsetLeft = offsetLeft;
      this.offsetTop = offsetTop;
      this.show_attention_view = true;
      this.loadData(page, name)
    },
    hideView(){
      this.show_attention_view = false
    }


  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.attentionUserView {
    position: absolute;
    left: 0;
    top: 0px;
    z-index: 9999;
  .userList {
    width: 200px;
    max-height: 200px;
    overflow: auto;
    background-color: #ffffff;
    border: solid 1px #d9d9d9;
    box-shadow: 0 0 6px rgba(0, 0, 0, .3);
    border-radius: 3px;
    padding: 0 2px;
    .user {
      font-size: 13px;
      color: #333333;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      overflow: hidden;
      cursor: pointer;
      &:hover {
        background-color: #eaeaec;
        color: #eb7350;
      }
    }
    .title {
      font-size: 12px;
      color: #333333;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      overflow: hidden;
    }
  }
}
</style>
